'use client';

import React from 'react';
import { AuthProvider } from '@/context/AuthContext';
import { ToastProvider } from '@/context/ToastContext';
import { FavoritesProvider } from '@/context/FavoritesContext';
import { InterestsProvider } from '@/context/InterestsContext';
import { ArrematacoesProvider } from '@/context/ArrematacoesContext';
import { ScraperProvider } from '@/context/ScraperContext';
import { UserPreferencesProvider } from '@/context/UserPreferencesContext';
import { ThemeProvider } from '@/context/ThemeContext';
import { NotificationsProvider } from '@/context/NotificationsContext';
import RouteGuard from '@/components/RouteGuard';

export default function Providers({ children }: { children: React.ReactNode }) {
  return (
    <ThemeProvider>
      <AuthProvider>
        <ToastProvider>
          <NotificationsProvider>
            <UserPreferencesProvider>
              <RouteGuard>
                <FavoritesProvider>
                  <InterestsProvider>
                    <ArrematacoesProvider>
                      <ScraperProvider>{children}</ScraperProvider>
                    </ArrematacoesProvider>
                  </InterestsProvider>
                </FavoritesProvider>
              </RouteGuard>
            </UserPreferencesProvider>
          </NotificationsProvider>
        </ToastProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}
